import { styled } from '@mui/material/styles';

export const MissingTemplateTooltipWrapper = styled('div')(() => ({
  paddingLeft: '8px',
}));
